import { render } from "./EditVM.vue?vue&type=template&id=1d7976e0&scoped=true"
import script from "./EditVM.vue?vue&type=script&lang=js"
export * from "./EditVM.vue?vue&type=script&lang=js"

import "./EditVM.vue?vue&type=style&index=0&id=1d7976e0&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder@2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d7976e0"]])

export default __exports__